import { render } from "./LoadEvents.vue?vue&type=template&id=b0a3d654"
import script from "./LoadEvents.vue?vue&type=script&lang=js"
export * from "./LoadEvents.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__